import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { HttpResponseDto } from "../model/common/httpResponseDto";
import { HotelMotelEnrollment } from "../model/enrollment/hotelMotelEnrollment";
import { OwnerEnrollment } from "../model/enrollment/ownerEnrollment";
import { PropertyEnrollment } from "../model/enrollment/propertyEnrollment";


@Injectable({
    providedIn: 'root'
  }) 
export class EnrollmentService{
    [x: string]: any;
    private baseUrl = `${environment.apiUrl}/enrollment`;

    constructor(private http: HttpClient) {}
    httpOptions = {
       headers: new HttpHeaders({
         'Content-Type':  'application/json',
          'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
       })
     };

     registerOwner(model: OwnerEnrollment) : Observable<HttpResponseDto>{
    
      return this.http.post<HttpResponseDto>(`${this.baseUrl}/saveOwnerEnrollment`, model).pipe(tap(data => {
          return data
       }));
     }

     registerProperty(model: PropertyEnrollment): Observable<HttpResponseDto>{
      return  this.http.post<HttpResponseDto>(`${this.baseUrl}/savePropertyEnrollment`, model, this.httpOptions).pipe(tap(data => {
        return data
     }));
   }

     registerHotelMotel(model: HotelMotelEnrollment): Observable<HttpResponseDto>{
      return this.http.post<HttpResponseDto>(`${this.baseUrl}/saveHotelMotelEnrollment`, model, this.httpOptions).pipe(tap(data => {
        return data
     }));
    }
}